import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Link } from "./menus/link";
import { AdminMenu, ClientMenu } from "./menus";

import SupervisionLogo from "../assets/supervision.png";

export const DashboardLayout: React.FC<any> = ({ children }) => {
  const [isOpened, setIsOpened] = useState(false);
  // const godMode = useReactiveVar(godModeVar);

  return (
    <div className=" bg-body min-h-screen">
      <nav className="sticky top-0 z-50 py-3 px-6 bg-white border-b border-gray-300">
        <div className="flex items-center justify-between">
          <Link to="/">
            <div className="flex items-center">
              <img
                src={SupervisionLogo}
                alt="Supervision Logo"
                width={30}
                className="mr-1"
              />
              <span className="text-xl font-semibold">SuperVision</span>
            </div>
          </Link>

          <div className="flex w-1/3 xl:w-1/6 justify-end">
            <button
              onClick={() => {
                setIsOpened(true);
              }}
              className="xl:hidden navbar-burger flex items-center rounded focus:outline-none"
            >
              <svg
                className=" block h-8 w-8 p-2 rounded"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
              >
                <title>Mobile menu</title>
                <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"></path>
              </svg>
            </button>
          </div>
        </div>
      </nav>

      <div
        id="content"
        className=" xl:ml-64 ml-0 bg-white border-gray-300 transition-all relative border-l z-10"
      >
        <div
          className={` ${
            isOpened ? "" : "hidden"
          } xl:block navbar-menu relative z-400 transition-all bg-white `}
        >
          <div
            onClick={() => {
              setIsOpened(false);
            }}
            className="navbar-backdrop fixed xl:hidden inset-0 opacity-10 z-50 bg-black "
          ></div>
          <nav className=" border-gray-300 fixed z-50 top-0 pt-16 overflow-hidden overflow-y-auto left-0 bottom-0 flex flex-col w-3/4 xl:w-64 sm:max-w-xs pb-8 bg-white transition-all">
            <div className="px-4 pb-6">
              <div className="mb-8 text-sm font-medium"></div>
            </div>
          </nav>
        </div>
        <div className="bg-body">
          <div className="min-h-screen">
            <Outlet />
          </div>
          <div className="w-full flex border-t border-gray-300 bg-white py-3 justify-center items-center mt-2">
            <span className="font-semibold">Scalance</span>
          </div>
        </div>
      </div>
    </div>
  );
};
